import { List } from "immutable";
import * as actions from "../actions/AdminPageListActions";
import { AdminPageListState, initialState } from "../store/AdminPageListState";
import buildReducer from "../utils/ReducerBuilder";

export const AdminPageListReducer = buildReducer<AdminPageListState>(initialState)
    .handle(actions.onAllReceived, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            loading: false,
            pages: List(action.payload.navItems),
        };
    })
    .handle(actions.updatePages, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            pages: action.payload,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/reducers/AdminPageListReducer.ts